import { apiClientWithRefreshToken } from "@/api/apiClient";
import { Pagination, Role } from "@/v2/types";

export default async function FindAllRoles({
    skip,
    limit,
    search,
}: {
    skip?: number;
    limit?: number;
    search?: string;
}): Promise<{ data: Role[]; pagination: Pagination }> {
    const res = await apiClientWithRefreshToken({
        url: "/roles",
        method: "GET",
        params: {
            skip: skip ?? 0,
            limit: limit ?? 10,
            ...(search && { search }),
        },
    });
    return res.data;
}
